export class Remark {
  constructor(
    public reference_no: string,
    public created_at: string,
    public created_by: string,
    public content: string
  ) { }
}
